module.exports = __webpack_public_path__ + "img/46.28b4ea18.jpg";